import React from 'react';
import CloseButton from '../../../../pageLayout/closeButton';

export function EmailFirstPageLayoutCloseButton() {
    return <CloseButton asButton />;
}
